import { ACTIVITY_FILTER_V2_MAP } from './v2';
import { ACTIVITY_FILTER_V3_MAP } from './v3';
/**
 * Map of available API versions and their collective activity filters.
 * You can test these against the `status-ui` repository with `yarn start-with-proxy` by linking the package.
 */
export var ACTIVITY_FILTER_COLLECTION = {
  v2: ACTIVITY_FILTER_V2_MAP,
  v3: ACTIVITY_FILTER_V3_MAP
};